exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card[data-v-a1494716]{min-width:100%;display:flex;margin-bottom:15px}.card-title[data-v-a1494716]{margin-top:0}.card-img-top[data-v-a1494716]{height:100px;object-fit:cover;margin-right:30px}.card-title a[data-v-a1494716]{color:#1a2b50;text-transform:uppercase;font-size:16px;line-height:26px}.card-text[data-v-a1494716]{font-size:14px;color:var(--grey-color,#5e6d77);font-weight:400}.card .hl-search[data-v-a1494716]{background-color:#ff0}.search-location .service-location[data-v-a1494716]{display:flex;align-items:center}.search-location .service-location i[data-v-a1494716]{margin-right:5px}@media only screen and (max-width:768px){.card[data-v-a1494716]{min-width:50%}}@media only screen and (max-width:480px){.card[data-v-a1494716]{min-width:100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/AppDisplayPost.vue?vue&type=style&index=0&id=a1494716&scoped=true&lang=css&
// module id = 157
// module chunks = 0